import { render, staticRenderFns } from "./MatchPotentialSearchBar.vue?vue&type=template&id=10075dec&scoped=true&"
import script from "./MatchPotentialSearchBar.vue?vue&type=script&lang=js&"
export * from "./MatchPotentialSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./MatchPotentialSearchBar.vue?vue&type=style&index=0&id=10075dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10075dec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
